import React, { useState, useEffect } from 'react';
import './styles/main.css';
import BrainVisualization from './components/BrainVisualization';
import HUD from './components/HUD';
import Slides from './components/Slides';
import DeepDive from './components/DeepDive';

function App() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideDuration, setSlideDuration] = useState(2.5);

  const SLIDES = 5;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const slideHeight = window.innerHeight;

      // Phase 1: Slides
      const slidePhaseHeight = slideDuration * slideHeight;

      // Calculate Normalized Progress for the Slide Section
      let rawProgress = Math.min(scrollY / (slidePhaseHeight * 0.9), 1.0);

      setScrollProgress(rawProgress);

      // Calculate current slide
      const newSlide = Math.min(
        Math.floor(rawProgress * SLIDES),
        SLIDES - 1
      );

      if (newSlide !== currentSlide) {
        setCurrentSlide(newSlide);
      }

      // Dim background and Hide Slides during deep dive
      const canvasContainer = document.getElementById('canvas-container');
      const textLayer = document.getElementById('text-layer');

      if (scrollY > slidePhaseHeight) {
        // We are in text mode (Transition phase: 500vh -> 600vh)
        const transitionRange = window.innerHeight; // 100vh margin
        const deepProgress = Math.min((scrollY - slidePhaseHeight) / transitionRange, 1.0);

        // Dim 3D background
        if (canvasContainer) {
          canvasContainer.style.opacity = Math.max(0.2, 1.0 - deepProgress * 0.8);
        }

        // Fade out Fixed Text Layer (Slides) to prevent overlap
        if (textLayer) {
          textLayer.style.opacity = Math.max(0, 1.0 - deepProgress * 1.5);
        }
      } else {
        if (canvasContainer) canvasContainer.style.opacity = 1.0;
        if (textLayer) textLayer.style.opacity = 1.0;
      }
    };

    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setSlideDuration(isMobile ? 3.5 : 2.5);
    };

    // Set body height to accommodate all content
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';

    // Initialize dimensions
    handleResize();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [currentSlide, slideDuration]);

  return (
    <div className="app">
      <div id="canvas-container">
        <BrainVisualization scrollProgress={scrollProgress} currentSlide={currentSlide} />
      </div>

      <HUD />

      {/* Spacer for slides */}
      <div id="slide-spacer" style={{ height: `${slideDuration * 100}vh` }}></div>

      <div id="text-layer">
        <Slides currentSlide={currentSlide} />
      </div>

      <DeepDive />
    </div>
  );
}

export default App;
